/**
 * 青山科技基金年份和日期配置常量
 * 用于管理每年度的基金申报信息和时间节点
 * 便于后续年度更新时快速修改
 */

const period = '六'
const year = 2026

export const YEAR_CONFIG = {
  // 年份标识
  year,

  period,

  description: `青山科技奖聚焦绿色、低碳、可持续发展。${year}年度，奖项资助在材料科学、化学、化学工程、环境科学、能源科学等学科领域有关键推动作用的青年科研工作者，主要关注绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制四大议题，特别鼓励数智技术与绿色低碳技术的交叉融合。`,

  // 评奖日程列表（供首页展示）
  scheduleItems: [
    {
      serial: '01',
      schedule: '启动申报',
      date: '2026年4月',
    },
    {
      serial: '02',
      schedule: '申报截止',
      date: '2026年7月',
    },
    {
      serial: '03',
      schedule: '启动评审',
      date: '2026年8月',
    },
    {
      serial: '04',
      schedule: '公示评审结果',
      date: '2026年11月',
    },
    {
      serial: '05',
      schedule: `公布第${period}届青山科技奖获奖人`,
      date: '2026年12月',
    },
  ],
};
